
export const get = (bucketId, fileId, path) => {
  return `/file/${bucketId}/${fileId}/content/${path}`;
};

export const getUnzippedUrl = get
export const getFileUrl = (bucketId, fileId, ext) => get(bucketId, fileId, `file.${ext}`)
export const getUrl = getFileUrl
export const getOriginRootKey = getFileUrl


// Anchored, and each segment is [^/]+ rather than .+ — a greedy .+ matched a
// key with more segments than this shape has and quietly folded the extras into
// whichever group won the backtrack, so "upload/a/b/c/d/e" parsed as orgId
// "a/b". None of the ids can contain a slash: orgId is a domain, the other two
// are uuids. A key that does not have exactly this shape is not an upload, and
// the handler treats it as an orphan.
export const uploadFileKeys = (srcKey) => {

  const keyRegex = /^upload\/([^/]+)\/([^/]+)\/([^/]+)\/([^/]+)$/;
  const match = keyRegex.exec(srcKey);
  if (match) {
    const [full, orgId, bucketId, fileId, filename] = match;
    return { orgId, bucketId, fileId, filename }
  }
  else {
    return null
  }
}


// Same tightening as uploadFileKeys, and here it is load-bearing: bucketId and
// fileId are substituted into the origin key, and with a greedy .+ a bucketId
// could carry path separators of its own.
export const extractFileKeys = (srcKey) => {

  const keyRegex = /^([^/]+)\/([^/]+)\/content\/(.+)$/;
  const match = keyRegex.exec(srcKey);
  if (match) {
    const [full, bucketId, fileId, path] = match;
    return { bucketId, fileId, path }
  }
  else {
    return null
  }
}